import { Currency } from "@redotech/money/currencies";
import type { ProgressBar as ProgressBarType } from "@redotech/redo-model/checkouts/checkout-optimization-settings";
import { ProgressBar } from "@redotech/redo-web/conversion/storefront-widgets/progress-bar";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useMemo } from "react";

export const PreviewSection = memo(function PreviewSection({
  progressBarConfig,
  shopCurrency,
}: {
  progressBarConfig:
    | {
        threshold: ProgressBarType["threshold"];
        ltThresholdText: string;
        gteThresholdText: string;
        progressBarColor: string;
      }
    | undefined;
  shopCurrency: Currency;
}) {
  const mockCart = useMemo(() => {
    if (!progressBarConfig) {
      return undefined;
    }

    const thresholdAmount = progressBarConfig.threshold.amount;
    const subtotal = Math.floor(thresholdAmount * 0.6);

    return { currency: shopCurrency, subtotal_price: subtotal, items: [] };
  }, [progressBarConfig, shopCurrency]);

  return (
    <Flex dir="column" flex={1} gap="3xl" p="3xl">
      <Text fontSize="md" fontWeight="semibold" textColor="primary">
        Preview
      </Text>
      {progressBarConfig && mockCart ? (
        <ProgressBar
          cart={mockCart}
          gteThresholdText={progressBarConfig.gteThresholdText}
          ltThresholdText={progressBarConfig.ltThresholdText}
          progressBarColor={progressBarConfig.progressBarColor}
          threshold={progressBarConfig.threshold}
        />
      ) : (
        <Flex
          align="center"
          bgColor="secondary"
          dir="row"
          justify="center"
          p="5xl"
          radius="md"
          w="full"
        >
          <Text fontSize="sm" textAlign="center" textColor="tertiary">
            The preview of the progress bar widget will appear when configured
          </Text>
        </Flex>
      )}
    </Flex>
  );
});
